export type EntrepotActivityOption = {
  value: string;
  title: string;
  parent: string;
  isAMainActivity: boolean;
};

export const entrepotActivities: EntrepotActivityOption[] = [
  {
    isAMainActivity: false,
    value: "reception",
    title: "Réception",
    parent: "",
  },
  {
    isAMainActivity: false,
    value: "reference",
    title: "À la référence",
    parent: "reception",
  },
  {
    isAMainActivity: false,
    value: "commande",
    title: "À la commande",
    parent: "reception",
  },
  {
    isAMainActivity: false,
    value: "stockage",
    title: "Stockage",
    parent: "",
  },
  {
    isAMainActivity: false,
    value: "Standard",
    title: "Standard",
    parent: "stockage",
  },
  {
    isAMainActivity: false,
    value: "hors-norme",
    title: "Hors-norme",
    parent: "stockage",
  },
  {
    isAMainActivity: false,
    value: "logistique",
    title: "Logistique de retour",
    parent: "",
  },
  {
    isAMainActivity: false,
    value: "tri",
    title: "Tri",
    parent: "logistique",
  },
  {
    isAMainActivity: false,
    value: "desctruction",
    title: "Destruction",
    parent: "logistique",
  },
  {
    isAMainActivity: false,
    value: "revalorisation",
    title: "Revalorisation",
    parent: "logistique",
  },
  {
    isAMainActivity: false,
    value: "preparation",
    title: "Préparation",
    parent: "",
  },
  {
    isAMainActivity: false,
    value: "kitting",
    title: "Kitting",
    parent: "preparation",
  },
  {
    isAMainActivity: false,
    value: "manutention",
    title: "À l'unité de manutention",
    parent: "preparation",
  },
  {
    isAMainActivity: false,
    value: "preparationReference",
    title: "À la référence",
    parent: "preparation",
  },
  {
    isAMainActivity: true,
    value: "central",
    title: "Gestion logistique",
    parent: "entrepot",
  },
  {
    isAMainActivity: true,
    value: "xDock",
    title: "X-dock",
    parent: "entrepot",
  },
];
